import React, { FC } from 'react';
import { IProps } from 'src/types/layout.types';
import styles from './shadow-box.module.less';

const ShadowBox: FC<IProps> = ({ children }) => {
	return <div className={styles.box}>{children}</div>;
};

export default ShadowBox;
